const angular = require('angular');
/**
 * Filter for search
 * 
 */

export function searchFilter() {
  return function (items, searchText) {
    if (!searchText || searchText == '') {
      return items;
    }
    var filtered = [];
    //  filter stuff here
    angular.forEach(items, function (item) {
      if (item && item.Label) {
        if (item.Label.name.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
          filtered.push(item);
        }
      }
    });
    return filtered;
  }
}
export default angular.module('nodeApp.searchFilter', [])
  .filter('searchFilter', searchFilter)
  .name;



// WEBPACK FOOTER //
// ./client/components/customFilters/searchFilter.ts